import { ChunkEntry } from '@atlassian/bitkit-diff';

import { ContextLine } from '../sagas/utils/convert-to-chunks-format';

import { appendToChunk } from './append-to-chunk';
import { prependToChunk } from './prepend-to-chunk';
import { updateLinePositions } from './update-line-positions';

export function mergeContextLinesWithChunks(
  chunks: ChunkEntry[],
  chunkId: string,
  contextLines: ContextLine[],
  beforeOrAfter: 'before' | 'after',
  hasMoreLines: boolean
) {
  const chunkIndex = chunks.findIndex(chunk => chunk.id === chunkId);
  let newChunks: ChunkEntry[] = [];

  if (beforeOrAfter === 'before') {
    newChunks = prependToChunk(chunks, chunkIndex, contextLines, hasMoreLines);
  } else {
    newChunks = appendToChunk(chunks, chunkIndex, contextLines, hasMoreLines);
  }

  return updateLinePositions(newChunks, chunkIndex);
}
